/* eslint-disable @typescript-eslint/no-explicit-any */
import { getFileUrl } from "@/lib/get-file-url";
import { useEffect, useState } from "react";

export const useDocumentImage = (prop: string[]) => {
  const [state, setGenericState] = useState({
    downImages: [],
    images: [],
    nextDisabled: true,
    prevDisabled: true,
    currentPage: 1,
    error: false,
    imageUrl: undefined,
    loading: true,
  });

  useEffect(() => {
    setGenericState((prev: any) => ({
      ...prev,
      nextDisabled:
        prev.images.length === 1 || prev.currentPage === prev.images.length,
      prevDisabled: prev.currentPage === 1,
      imageUrl: prev.images[prev.currentPage - 1],
    }));
  }, [state.currentPage]);

  useEffect(() => {
    setTimeout(() => {
      setGenericState((prev: any) => ({
        ...prev,
        loading: false,
      }));
    }, 1000);
  }, [state.imageUrl]);

  // const convertImageUrl = (prop: string[]) => {
  //   return prop?.map((item: string) => getImageUrl(item));
  // };

  // useEffect(() => {
  //   setGenericState((prev: any) => ({
  //     ...prev,
  //     images: convertImageUrl(prop),
  //     error: prev.images?.[0] ? false : true,
  //   }));
  // }, [prop]);

  const convertImageUrl = async (prop: string[]) => {
    return Promise.all(prop?.map((item) => getFileUrl(item)));
  };

  useEffect(() => {
    (async () => {
      try {
        const images = await convertImageUrl(prop);
        setGenericState((prev: any) => ({
          ...prev,
          images,
          error: images.length > 0 ? false : true,
        }));
      } catch (error) {
        console.error("Error fetching images:", error);
        setGenericState((prev: any) => ({
          ...prev,
          images: [],
          error: true,
        }));
      }
    })();
  }, [prop]);

  const setState = ({ type }: { type: string }) => {
    switch (type) {
      case "next": {
        setGenericState((prev: any) => ({
          ...prev,
          currentPage: prev.currentPage + 1,
        }));
        break;
      }
      case "prev": {
        setGenericState((prev: any) => ({
          ...prev,
          currentPage: prev.currentPage - 1,
        }));
        break;
      }
      case "error": {
        setGenericState((prev: any) => ({
          ...prev,
          error: true,
        }));
        break;
      }
      default:
        break;
    }
  };
  return { state, setState };
};

// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { getFileUrl } from "@/lib/get-file-url";
// import { useEffect, useState } from "react";

// export const useDocumentImage = (prop: string[]) => {
//   const [state, setGenericState] = useState({
//     downImages: [],
//     images: [],
//     nextDisabled: true,
//     prevDisabled: true,
//     currentPage: 1,
//     error: false,
//     imageUrl: undefined,
//     loading: true,
//   });

//   useEffect(() => {
//     setGenericState((prev: any) => ({
//       ...prev,
//       nextDisabled:
//         prev.images.length === 1 || prev.currentPage === prev.images.length,
//       prevDisabled: prev.currentPage === 1,
//       imageUrl: prev.images[prev.currentPage - 1],
//     }));
//   }, [state.currentPage]);

//   useEffect(() => {
//     setTimeout(() => {
//       setGenericState((prev: any) => ({
//         ...prev,
//         loading: false,
//       }));
//     }, 1000);
//   }, [state.imageUrl]);

//   // const convertImageUrl = (prop: string[]) => {
//   //   return prop?.map((item: string) => getImageUrl(item));
//   // };

//   // useEffect(() => {
//   //   setGenericState((prev: any) => ({
//   //     ...prev,
//   //     images: convertImageUrl(prop),
//   //     error: prev.images?.[0] ? false : true,
//   //   }));
//   // }, [prop]);

//   const convertImageUrl = async (prop: string[]) => {
//     return Promise.all(prop.map((item) => getFileUrl(item)));
//   };

//   useEffect(() => {
//     (async () => {
//       try {
//         const images = await convertImageUrl(prop);
//         setGenericState((prev: any) => ({
//           ...prev,
//           images,
//           error: images.length > 0 ? false : true,
//         }));
//       } catch (error) {
//         console.error("Error fetching images:", error);
//         setGenericState((prev: any) => ({
//           ...prev,
//           images: [],
//           error: true,
//         }));
//       }
//     })();
//   }, [prop]);

//   const setState = ({ type }: { type: string }) => {
//     switch (type) {
//       case "next": {
//         setGenericState((prev: any) => ({
//           ...prev,
//           currentPage: prev.currentPage + 1,
//         }));
//         break;
//       }
//       case "prev": {
//         setGenericState((prev: any) => ({
//           ...prev,
//           currentPage: prev.currentPage - 1,
//         }));
//         break;
//       }
//       case "error": {
//         setGenericState((prev: any) => ({
//           ...prev,
//           error: true,
//         }));
//         break;
//       }
//       default:
//         break;
//     }
//   };
//   return { state, setState };
// };
